import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { TransactionListDurationCell } from './transaction-list-duration.cell';
import { TransactionListDurationHeader } from './transaction-list-duration.header';

export const TransactionListDurationColumn: DisplayColumnDef<
  TransactionModel,
  unknown
> = {
  id: 'duration',
  enableSorting: false,
  header: TransactionListDurationHeader,
  cell: TransactionListDurationCell,
  meta: { maxWidth: '120px', width: '100px' },
};
